import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export type InquiryRelatedDivision = {
  id: number
  inquiry_id: number
  division_id: number
  division_name: string
  short_division_name: string | null
  service_name: string | null
  updated_at: number
  created_at: number
}

type GetInquiryRelatedDivisionsResponse = {
  total: number
  inquiry_related_divisions: InquiryRelatedDivision[]
}

export function useInquiryRelatedDivisions(inquiryId: number) {
  return useQuery({
    queryKey: queryKeys.inquiry.relatedDivisions(inquiryId),
    queryFn: () =>
      apiFetch<GetInquiryRelatedDivisionsResponse>(`/api/inquiry/${inquiryId}/related-divisions`, {
        method: 'GET',
      }),
    enabled: inquiryId > 0,
  })
}
